module.exports = __webpack_public_path__ + "img/popshop.ae53a575.gif";